import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { IOrder } from '../../types/order';
import RusPostManifestFormModal, { IRusPostManifestFormModalRef } from './manifest-form';

interface IRusPostSendManifestButtonProps {
    selectedRows: IOrder[];
    onHide?: () => void;
}

function RusPostSendManifestButton({ selectedRows, onHide }: IRusPostSendManifestButtonProps) {
    const { t } = useTranslation();
    const modal = useRef<IRusPostManifestFormModalRef>();

    const onClick = () => {
        modal.current?.show(selectedRows);
    };

    return (
        <>
            <Button type="primary" onClick={onClick}>
                {t('sendManifest')}
            </Button>
            <RusPostManifestFormModal ref={modal} onHide={onHide} />
        </>
    );
}

export default RusPostSendManifestButton;
